import {gql} from '@apollo/client'

export interface PagedResult<T> {
  pageInfo: {
    hasNextPage: boolean
    endCursor: string
  }
  totalCount: number
  edges: {node: T}[]
}

export const GET_CUSTOMERS = gql`
  query {
    customers {
      nodes {
        customerId
        displayName
        taxNumber
        salesRegionId
      }
    }
    salesRegions {
      nodes {
        salesRegionId
        displayName
      }
    }
  }
`

export const GET_SALESPERSON_ID = gql`
query ($salespersonGuid: UUID!) {
  salesPeople (where: {guid: {eq: $salespersonGuid}}) {
    edges {
      node {
        salesPersonId
      }
    }
  }
}`

export const GET_EMPTY_ACTIVITY = gql`
  query ($paramGuid: UUID!) {
    createEmptyActivity(activityTypeGuid: $paramGuid) {
      activityTypeGuid
      notes
      planDateTime
      planEndDateTime
      activityStatements {
        titleText
        statementCode
        statementText
        dataType
        notes

        jsonValues {
          items {
            option
          }
        }
      }
    }
  }
`

export const GET_CUSTOMER_WORKINCUSTOMERID = gql`
query($guid: UUID!) {
  salesPeople(where: {guid: {eq: $guid}}) {
    edges {
      node {
        worksInCustomerId
        salesPersonReference
      }
    }
  }
}
`


export const GET_ACTIVITY_INFO= gql`
query{
  activityTypes(where: {guid:{eq:"2978C75D-D89F-4EE4-8DA4-D82FA90F2605"}}) {
    edges{
      node {
        activityTypeId
         workflow {
          startActivityStatusId
        }
        activityTypeStatements {
          statementCode
          titleText
          statementText
          rank
          dataType
          activityTypeStatementId
          format
        }
      }
    }
  }
}
`

export const CREATE_ACTIVITY_FROM_EMPTY = gql`
mutation ($model: InsertEmptyActivityModelInput) {
  createActivityFromEmptyActivity (model: $model) {
      response {
        status
        detail
      }
      activity {
        activityId
        updateVersion
        guid
        activityType {
          guid
        }
        activityStatements {
          value
        }
      }
    }
  }
`

export const UPDATE_ACTIVITY_STATUS = gql`
mutation($model: UpdateActivityToNextStatusModelInput) {
  updateActivityToNextStatus (model: $model) {
    response {
      status
      detail
    }
    activity {
      activityId
      updateVersion
      guid
    }
  }
}
`

export const GET_TOKEN = gql`
  query GetToken($email: String!, $password: String!) {
    login(email: $email, password: $password) {
      response
      refresh
      expireHours
      userInfo {
        salesPersonGuid
        salesPersonName
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles
        tenantId
        rolesGuids
        sessionGuid
      }
    }
  }
`

export const GET_LAST_ACTIVITY = gql ` 
query ($paramGuid: UUID!, $customerId
  : Int!) {
  activities (
    first: 1,
    order: {activityId: DESC},
    where: {
      activityType: {
        guid: {
          eq: $paramGuid
        }
      },
      customerId: {
        eq: $customerId
      }
      
    }) {
    edges {
      node {
        planDateTime
        activityStatements {
          value  
        }
      }
    }
  }
}
`

export const GET_ACTIVITY_HISTORY = gql`
query ($lastActivityNumber: Int!, $paramGuid: UUID!, $customerId: Int!){
  activities (first: $lastActivityNumber , order: { planDateTime: DESC } , 
  where: {  and:[{
    activityType: { guid: { eq: $paramGuid } } } , 
    {customerId: {eq: $customerId} }]  }) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        notes
        customerId
        activityType {
          guid
          activityTypeId
        }
        activityId
        activityStatements {
          activityStatementId
          titleText
          statementText
          statementCode
          value
          guid
          notes
        }
        planDateTime
      }
    }
  }
}
`

export const GET_ACTIVITIES = gql`
  query GetActivities($cursor: String, $salesPersonGuid: UUID) {
    activities(after: $cursor, where: {createSalesPerson: {guid: {eq: $salesPersonGuid}}}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          createSalesPerson {
            name
          }
          guid
          updateVersion
          activityId
          projectId
          planDateTime
          planEndDateTime
          activityStatusId
          customer {
            customerId
            displayName
            guid
            taxNumber
            customerCategoryId
            customerTypeId
            customerReference
          }
          activityStatements {
            guid
            activityTypeStatementId
            activityStatementId
            titleText
            value
            statementText
            statementCode
            notes
            activityDocuments {
              guid
              activityStatementId
              document {
                guid
                fileName
              }
            }
          }
          activityType {
            guid
            workflow {
              workflowId
              activityStatusWorkflows {
                toActivityStatusId
                role
              }
            }
          }
          activityStatus {
            activityStatusId
            guid
            displayName
            activityStatusWorkflowToActivityStatusesWf {
              activityStatusWorkflowId
              toActivityStatusId
              isDefault
              role
            }
          }
          salesPerson {
            salesPersonId
            name
          }
        }
      }
    }
  }
`

export const GET_SETTING = gql`
  query GET_SETTING($key: String) {
    settings(where: {settingKey: {eq: $key}}) {
      edges {
        node {
          settingKey
          value
          settingId
          tenantId
          guid
        }
      }
    }
  }
`
export const GET_REFRESHED_TOKEN = gql`
  query GetToken($refresh: String!) {
    refreshLogin(refresh: $refresh) {
      response
      refresh
      expireHours
      userInfo {
        salesPersonGuid
        salesPersonName
        salesRegionHierarchyCode
        salesRegionReference
        salesRegionDisplayName
        roles
        tenantId
      }
    }
  }
`

export const GET_ACTUEL_NEWS = gql`
  query ($cursor: String, $todayDate: DateTime) {
    activities(
      after: $cursor
      where: {
        planDateTime: {lte: $todayDate}
        planEndDateTime: {gte: $todayDate}
        activityType: {guid: {eq: "3C2922FD-AD4C-4870-B737-69DD81F3F1E6"}}
        activityStatus: {isCompleted: {eq: true}}
      }
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          activityId
          planDateTime
          planEndDateTime
          createDateTime
          activityStatements {
            statementCode
            statementText
            value
            notes
          }
        }
      }
    }
  }
`

export const GET_HIERARCHY_LIST = gql`
  query ($guid1: UUID!, $guid2: UUID!, $guid3: UUID!, $guid4: UUID!) {
    productHierarchies(
      where: {
        or: [{guid: {eq: $guid1}}, {guid: {eq: $guid2}}, {guid: {eq: $guid3}}, {guid: {eq: $guid4}}]
      }
    ) {
      edges {
        node {
          displayName
          productHierarchyCode
          guid
          rank
          documentRelations {
            rank
            document {
              documentTypeCode
              fileName
              originalFileName
            }
          }
        }
      }
    }
  }
`

export const GET_SUB_HIERARCHIES = gql`
  query ($cursor: String, $topHieGuid: UUID!) {
    productHierarchies(after: $cursor, where: {guid: {eq: $topHieGuid}}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          displayName
          productHierarchyCode
          guid
          rank
          subProductHierarchies {
            displayName
            guid
          }
          products {
            displayName
            sku
            guid
            documentRelations {
              rank
              document {
                documentTypeCode
                fileName
                originalFileName
              }
            }
          }
          productProductHierarchies {
            product {
              displayName
              sku
              guid
              documentRelations {
                rank
                document {
                  documentTypeCode
                  fileName
                  originalFileName
                }
              }
            }
          }
        }
      }
    }
  }
`

export const GET_PRODUCT_DETAIL = gql`
  query ($productGuid: UUID!) {
    products(where: {guid: {eq: $productGuid}}) {
      edges {
        node {
          displayName
          guid
          sku
          shortDescription
          detailedDescription
          productTags {
            tagText
          }
          documentRelations {
            guid
            rank
            document {
              documentTypeCode
              fileName
              originalFileName
              displayName
              documentId
            }
          }
        }
      }
    }
  }
`

export const SEARCH_PRODUCT = gql`
  query ($searchString: String!) {
    products(
      where: {
        or: [
          {displayName: {contains: $searchString}}
          {sku: {contains: $searchString}}
          {productReference: {contains: $searchString}}
          {shortDescription: {contains: $searchString}}
          {detailedDescription: {contains: $searchString}}
        ]
      }
    ) {
      edges {
        node {
          displayName
          guid
          sku
          shortDescription
          detailedDescription
          productImages {
            imageType
            imageFileName
            imageCode
            rank
          }
        }
      }
    }
  }
`

export const SEARCH_PRODUCTTAG = gql`
  query ($searchString: String!) {
    productTagList(where: {or: [{tagText: {contains: $searchString}}]}) {
      edges {
        node {
          tagText
        }
      }
    }
  }
`

export const SEARCH_PRODUCT_HIERARCHY = gql`
  query ($searchString: String!) {
    productHierarchies(where: {or: [{displayName: {contains: $searchString}}]}) {
      edges {
        node {
          displayName
          guid
        }
      }
    }
  }
`

export const GET_PRODUCT_HIERARHCY_BY_DEPTH = gql`
  query ($cursor: String) {
    productHierarchies(
      after: $cursor
      where: {depth: {eq: 2}, productHierarchyCode: {startsWith: "SP"}}
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          displayName
          productHierarchyCode
          guid
          rank
          documentRelations {
            rank
            document {
              documentTypeCode
              fileName
              originalFileName
            }
          }
        }
      }
    }
  }
`

export const GET_PRODUCTS_BY_TAGTEXT = gql`
  query ($cursor: String, $tagText: String) {
    products(after: $cursor, where: {productTags: {some: {tagText: {eq: $tagText}}}}) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          displayName
          guid
          sku
          shortDescription
          detailedDescription
          documentRelations {
            rank
            document {
              documentTypeCode
              fileName
              originalFileName
            }
          }
        }
      }
    }
  }
`
